<template>
  <div style="min-height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="desktop ">
      <el-row
        style="margin: auto;"
        :gutter="20"
        class="full-width container top-spacing"
      >
        <el-col :sm="16" :md="13" :lg="13" :xl="13">
          <div class="tee-time-container mb-20 full-width">
            <div class="logo-container">
              <img :src="icons.GolfIcon" alt="" />
              <h3 class="title-booking c-inherit-text">
                {{ $t("bookingRequestSentQuickly") }}
              </h3>
            </div>
            <div class="info-tee-time">
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("fieldName") }}</p>
                <p class="name-item ">
                  {{ objectData.sub_title }}
                </p>
              </div>
              <!-- <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">Mã Booking</p>
                <p class="name-item">BK2001</p>
              </div> -->
              <div class="divider-view "></div>

              <div class="item-content">
                <p class="title-item mr-20">{{ $t("bookingDate") }}</p>
                <p class="name-item">{{ dateNow }}</p>
              </div>
              <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("playDate") }}</p>
                <p class="name-item">
                  {{ convertDateTimestamp(objectData.date_played) }}
                </p>
              </div>
              <div class="divider-view "></div>

              <div class="item-content">
                <p class="title-item mr-20">{{ $t("time") }}</p>
                <p class="name-item">
                  {{
                    listTimeTee.find(
                      item => item.value === objectData.step_select
                    ).label
                  }}
                </p>
              </div>
              <div class="divider-view "></div>

              <div class="item-content">
                <p class="title-item mr-20">{{ $t("numberOfPlayers") }}</p>
                <p class="name-item number-golfed">
                  {{ objectData.total_user }}
                </p>
              </div>
            </div>
          </div>
          <p class="text-thanks fw-cv2 c-inherit-text">
            {{ $t("thankYouForBooking") }}.<br />
            {{ $t("contactToConfirmBooking") }}
          </p>
          <p class="contact">
            {{ $t("encounterBookingIssues") }}<br />
            {{ $t("contactNumber") }}
          </p>
        </el-col>
      </el-row>
    </div>
    <div class="mobile">
      <el-row style="padding: 80px 20px 100px 20px;" class="full-width">
        <el-col :xs="24" :sm="16" :md="16" :lg="16">
          <div class="tee-time-container mb-20 full-width">
            <div class="logo-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="55"
                height="51"
                viewBox="0 0 55 51"
                fill="none"
              >
                <path
                  d="M46.0981 37.7908C45.3727 37.4748 44.5218 37.6397 43.9917 38.2168C43.7546 38.4641 43.5035 38.684 43.2384 38.8764C42.6804 39.3985 41.7876 39.3573 41.2715 38.8077C41.0204 38.5328 40.8809 38.1756 40.8948 37.8046V36.7603C40.9367 35.4549 39.9044 34.3557 38.5792 34.3145C38.356 34.3145 38.1328 34.3282 37.9235 34.3832C36.8912 34.5618 35.9008 34.9465 35.0219 35.5237C33.627 36.4305 32.8458 36.1695 32.3157 34.5481C31.8972 33.3252 30.9207 32.3771 29.6791 31.9648C28.1726 31.3465 26.4567 31.429 25.0199 32.1984C24.699 32.3496 24.3642 32.487 24.0294 32.5969C23.2483 32.8168 22.4113 32.4183 22.1044 31.6763C21.7975 30.8793 21.3929 30.1373 20.9047 29.4366C20.4443 28.8457 19.8724 28.3373 19.2307 27.9388C18.0868 27.1831 17.8357 26.5648 18.5192 25.3419C19.1888 24.2701 19.7329 23.1159 20.1095 21.9067C20.7233 20.1892 20.1095 18.293 18.575 17.2624C18.2542 17.0151 17.9613 16.7403 17.6962 16.438C17.2777 16.0395 17.2638 15.3799 17.6683 14.9677C17.6683 14.9677 17.6823 14.954 17.6962 14.9402C18.045 14.5555 18.4355 14.212 18.7843 13.8273C19.5655 13.0715 20.0677 12.0685 20.1793 10.9967C20.263 10.2822 19.9421 9.58142 19.3423 9.18294C18.9796 8.94935 18.6029 8.7295 18.2124 8.53714C17.9334 8.39973 17.6823 8.23484 17.4451 8.04247C16.9987 7.69896 16.915 7.06689 17.2638 6.61345C17.2917 6.58597 17.3056 6.55849 17.3335 6.53101C17.7241 6.05009 18.1984 5.62413 18.7285 5.29436C19.4818 4.82718 19.8445 3.93404 19.6352 3.08212C19.3423 2.01036 18.2124 1.36455 17.1243 1.6531C17.0685 1.66684 17.0127 1.68058 16.9569 1.70806C9.21469 4.4287 3.27204 10.6669 1.01217 18.4578C-2.93565 31.9923 5.01578 46.1176 18.7564 50.0062C29.2048 52.9605 40.4205 49.1681 46.8235 40.5115C47.4373 39.7145 47.2699 38.5741 46.4608 37.9695C46.3492 37.887 46.2237 37.8183 46.0981 37.7634V37.7908V37.7908ZM15.7014 19.7769C16.7058 21.6182 16.4686 23.8716 15.0876 25.4518C14.5296 26.2075 13.4415 26.3724 12.6743 25.8228C12.5348 25.7266 12.4092 25.6029 12.2976 25.4518C11.1398 23.6793 10.9305 21.4533 11.7536 19.5021C12.1442 18.6227 13.1625 18.2105 14.0553 18.5678C14.7388 18.7464 15.3247 19.1861 15.7014 19.7769ZM13.4554 10.502C14.2785 9.77379 15.4921 9.69135 16.3989 10.3097C16.636 10.5158 16.7895 10.7906 16.8592 11.0929C16.9987 11.8761 16.8453 12.6731 16.3989 13.3326C15.7851 14.4731 14.8644 15.4212 13.7344 16.0807C13.1904 16.5479 12.3813 16.4929 11.907 15.9571C11.6978 15.7097 11.5722 15.4074 11.5862 15.0777C11.5304 14.5555 11.5304 14.0196 11.5862 13.4975C11.8931 12.3433 12.5487 11.299 13.4554 10.502V10.502ZM5.55982 21.4945C5.39242 21.6869 5.14133 21.7968 4.87628 21.7831C4.65308 21.6869 4.49963 21.4808 4.45778 21.2472C4.19274 19.7632 4.52753 18.2242 5.36452 16.9601C5.51797 16.7265 5.76907 16.5891 6.04807 16.5891C6.24337 16.5891 6.46656 16.9601 6.52236 17.1937C6.70371 18.1006 6.70371 19.0349 6.52236 19.9418C6.20152 20.4777 5.95042 21.0273 5.55982 21.4945ZM8.93569 11.8761C8.74039 11.9585 8.51719 11.9585 8.3219 11.8761C8.2103 11.8761 8.22425 11.5463 8.16845 11.3265C8.41955 10.8868 8.71249 10.4746 9.06124 10.0898C9.78663 9.45775 10.5399 8.85317 11.3351 8.2898C11.4746 8.17988 11.8931 8.17988 11.9489 8.2898C12.0605 8.49591 12.0605 8.75698 11.9489 8.96309C11.2793 10.1997 10.233 11.2166 8.97754 11.8761H8.93569V11.8761ZM8.1545 31.6213C7.66625 31.0992 7.26171 30.5083 6.95481 29.8625C6.46656 28.7908 6.31312 27.5953 6.50841 26.4274C6.75951 26.1113 6.99666 25.5892 7.28961 25.5617C7.736 25.5617 8.1545 25.7678 8.44745 26.0976C9.45184 27.2793 9.91218 28.8045 9.74478 30.3297C9.74478 30.7144 9.63318 31.0854 9.45184 31.4152C9.31234 31.8 8.87989 31.9923 8.48929 31.8549C8.36375 31.8137 8.2382 31.7312 8.1545 31.6213V31.6213ZM10.5818 40.3466C10.2749 40.1542 9.99588 39.9206 9.74478 39.6733C9.15889 39.055 8.60089 38.4092 8.08475 37.7359C7.9034 37.4748 7.7918 37.1725 7.7639 36.8565C7.736 36.5954 7.8197 36.3481 8.00105 36.1557C8.22425 36.0595 8.47534 36.0595 8.69854 36.1557C9.98193 36.829 10.9724 37.942 11.4885 39.2748C11.5583 39.4397 11.5862 39.6321 11.5862 39.8107C11.5304 40.3466 11.2374 40.5527 10.5818 40.3466V40.3466ZM16.1617 36.142C15.1155 35.5924 14.2366 34.7679 13.6507 33.7511C13.1346 32.9954 12.8277 32.1297 12.758 31.2366C12.5906 30.1099 13.3857 29.0518 14.5296 28.8732C14.9202 28.8182 15.3108 28.8732 15.6735 29.0244C17.0685 29.6564 18.1566 30.7969 18.7006 32.2122C19.1191 33.0229 19.2307 33.9572 19.0214 34.8366C18.8122 35.8672 17.7939 36.5542 16.7476 36.3481C16.5523 36.3069 16.357 36.2382 16.1757 36.142H16.1617ZM20.5978 43.9604C20.4304 43.9741 20.263 43.9741 20.0956 43.9604C19.8584 43.9604 19.6213 43.9604 19.4399 43.8779C18.1705 43.4794 17.0685 42.6825 16.3152 41.6107C16.1617 41.3909 16.0641 41.1435 16.0222 40.8825C15.8688 40.058 16.3012 39.5084 17.1382 39.5084C18.854 39.5496 20.4443 40.4565 21.3232 41.913C21.4766 42.1878 21.5743 42.4901 21.6022 42.8062C21.7417 43.3008 21.4348 43.7955 20.9465 43.9329C20.8349 43.9604 20.7233 43.9741 20.6117 43.9604H20.5978ZM22.7321 38.7527C21.8951 38.0794 21.5464 36.9664 21.8533 35.9359C22.1044 35.5924 22.3973 35.2626 22.7321 34.9878C24.6153 33.8885 27.0008 34.0809 28.6748 35.4687C29.6791 36.2794 29.8186 37.7359 29.0096 38.7115C28.7306 39.0412 28.3679 39.2886 27.9494 39.4397C26.2196 40.168 24.2247 39.9069 22.7461 38.7527H22.7321ZM29.8744 46.5161C28.4795 46.9833 26.931 46.8047 25.6895 46.0215C25.4105 45.8016 25.2291 45.4856 25.1873 45.1421C25.1873 44.7298 25.536 44.5237 25.9127 44.4001C26.9031 44.139 27.9354 44.139 28.9258 44.4001C29.3304 44.5787 29.7349 44.7848 30.1116 45.0184C30.5161 45.2108 30.6696 45.6917 30.4743 46.0902C30.3627 46.31 30.1395 46.4749 29.8884 46.5161H29.8744V46.5161ZM32.6644 42.284C32.3017 42.0917 31.9669 41.8718 31.6461 41.6245C30.9904 41.0199 30.9346 40.0168 31.5345 39.3573C32.3436 38.4229 33.4735 37.8183 34.715 37.6672C35.1196 37.626 35.5102 37.626 35.9147 37.6672C36.668 37.626 37.3655 38.0519 37.6585 38.7389C37.9933 39.4947 37.8538 40.3741 37.2958 40.9924C36.0961 42.1878 34.3663 42.6688 32.7063 42.284H32.6644V42.284ZM39.9881 43.026C39.1093 44.1802 37.8956 45.0321 36.5006 45.4856C36.2216 45.5543 35.9426 45.5955 35.6497 45.623C35.6497 45.4444 35.4544 45.252 35.4823 45.1008C35.5241 44.8947 35.6218 44.6886 35.7613 44.5237C36.6959 43.397 37.9375 42.5588 39.3325 42.1054C39.6114 42.0642 39.9044 42.0642 40.1834 42.1054C40.1415 42.4489 40.1834 42.8199 40.0299 43.026H39.9881V43.026Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M36.5964 1.48798L37.4752 3.23303L39.4282 3.50784L38.0193 4.86816L38.3541 6.79184L36.5964 5.88496L34.8526 6.79184L35.1874 4.86816L33.7646 3.50784L35.7315 3.23303L36.5964 1.48798Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M43.8085 5.61174L44.0317 7.53542L45.7615 8.46978L43.962 9.26673L43.6132 11.1767L42.288 9.73391L40.3211 9.99498L41.3115 8.30489L40.4466 6.55984L42.3856 6.95832L43.8085 5.61174Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M30.7988 0.247331L30.3384 2.14353L31.6497 3.58629L29.6828 3.73744L28.6784 5.41379L27.939 3.61377L26 3.20156L27.5066 1.93742L27.3113 0L28.9992 1.03054L30.7988 0.247331Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M51.9989 19.6267L50.8969 21.2481L51.6223 23.0481L49.7251 22.526L48.2045 23.7764L48.1348 21.8252L46.4608 20.7809L48.3161 20.1077L48.7904 18.2252L50.018 19.7504L51.9989 19.6267Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M51.9841 27.8298L50.3798 28.984L50.4496 30.9351L48.8454 29.7947L46.9761 30.4542L47.5759 28.5992L46.3762 27.0603L48.3432 27.0465L49.4592 25.4389L50.0869 27.2939L51.9841 27.8298Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M34.3055 23.8562C34.491 23.5932 34.5767 23.4279 34.698 23.2927C40.236 17.4624 45.774 11.6321 51.3049 5.79428C51.883 5.18571 52.5324 4.87015 53.3603 5.05047C54.8447 5.37354 55.5013 7.23683 54.5664 8.49906C54.4379 8.67187 54.288 8.82965 54.1382 8.98743C48.1006 15.3512 42.0558 21.7074 36.0183 28.0712C34.8479 29.3033 33.7345 29.3108 32.5784 28.0862C30.6016 26.005 28.6176 23.9163 26.6407 21.8351C26.0198 21.1815 25.8486 20.4001 26.134 19.5361C26.4124 18.6871 27.019 18.2062 27.8611 18.101C28.5462 18.0184 29.1243 18.2889 29.6096 18.7998C31.0298 20.2949 32.4499 21.7901 33.863 23.2852C33.9915 23.4204 34.0914 23.5782 34.3055 23.8562Z"
                  :fill="bg.c_border"
                />
              </svg>
              <!-- <img :src="icons.GolfIcon" alt="" /> -->
              <h3 class="title-booking fw-cv1 c-inherit-text">
                {{ getTitle() }}
              </h3>
            </div>
            <div class="info-tee-time">
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("fieldName") }}</p>
                <p class="name-item  fw-cv2">
                  {{ objectData.sub_title }}
                </p>
              </div>
              <!-- <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">Mã Booking</p>
                <p class="name-item">BK2001</p>
              </div> -->
              <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("bookingDate") }}</p>
                <p class="name-item fw-cv2">{{ dateNow }}</p>
              </div>
              <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("playDate") }}</p>
                <p class="name-item fw-cv2">
                  {{
                    convertDateTimestamp(objectData.date_played, "DD-MM-YYYY")
                  }}
                </p>
              </div>
              <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("time") }}</p>
                <p class="name-item fw-cv2">
                  {{
                    listTimeTee.find(
                      item => item.value === objectData.step_select
                    ).label
                  }}
                </p>
              </div>
              <div class="divider-view "></div>
              <div class="item-content">
                <p class="title-item mr-20">{{ $t("numberOfPlayers") }}</p>
                <p class="name-item fw-cv2">
                  {{ objectData.total_user }}
                </p>
              </div>
            </div>
          </div>
          <p class="text-thanks fw-cv2 c-inherit-text">
            {{ $t("thankYouForBooking") }}<br />
            {{ $t("contactToConfirmBooking") }}
          </p>
          <p @click="handleCall" class="contact fw-cv2">
            {{ $t("encounterBookingIssues") }}<br />
            {{ $t("contactNumber") }}
          </p>
        </el-col>
      </el-row>
    </div>
    <el-popover
      class="popover-table-golfed"
      ref="popover"
      placement="bottom"
      trigger="click"
    >
      <el-table
        class="table-golfed-booked"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" label="STT" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="name" :label="$t('wap.text27')" width="120">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="vid" label="VID" width="80">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.vid }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="hio" :label="$t('wap.text28')" width="120">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.hio }}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-popover>
    <el-popover
      class="popover-table-golfed"
      ref="popoverMobile"
      placement="bottom"
      trigger="click"
      width="350"
    >
      <el-table
        class="table-golfed-booked"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" label="STT" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="name" :label="$t('wap.text27')" width="120">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="vid" label="VID" width="80">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.vid }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="hio" :label="$t('wap.text28')" width="120">
          <template slot-scope="{ row }">
            <p class="m-0 c-bold-text ">{{ row.hio }}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-popover>
  </div>
</template>

<script>
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import GolfIcon from "@/assets/img/svg/golf-icon.svg";
import { getBackGround } from "@/utils/wapAuth";
import { sessions } from "@/constant/contant";
import { formatDate, convertDateTimestamp } from "@/utils/formatData";
import moment from "moment";
import { mapGetters } from "vuex";
import { isEmpty } from "@/utils/validate";
import { getToken } from "../../../../utils/wapAuth";
import { SOURCE_BANK } from "../../../../constant/contant";

export default {
  components: {
    MainNavBarWapV2
  },
  bodyClass: "home-page",
  props: {},
  data() {
    return {
      dateNow: moment().format("DD-MM-YYYY"),
      objectData: this.$store.getters.body_booking_fast || {},
      tableData: [],
      formRequest: {},
      rules: {},
      isActive: 0,
      listTimeTee: sessions,
      infoHeader: {
        title: this.$t("bookField"),
        isShowHomeIcon: true,
        routerGo: -2
      },
      bg: getBackGround(),

      icons: {
        GolfIcon
      }
    };
  },
  created() {
    if (isEmpty(this.body_booking_fast)) {
      this.$router.push({ path: "/wap" });
      return;
    }
    console.log(
      "this.$store.getters.body_booking_fast___________",
      this.$store.getters.body_booking_fast
    );
  },
  watch: {},
  computed: {
    ...mapGetters(["body_booking_fast"])
  },
  methods: {
    getTitle() {
      if (getToken().bank_id != SOURCE_BANK.BIDV)
        return this.$t("bookingRequestSentQuickly");
      else return this.$t("wap.text121");
    },
    handleCall() {
      window.location.href = "tel:02471001088";
    },
    indexMethod(index) {
      return index + 1;
    },
    handleFilter(val) {
      this.isActive = val;
    },
    formatDate,
    convertDateTimestamp
  }
};
</script>
<style>
.table-golfed-booked .el-table__header-wrapper table {
  display: none;
}
.el-popover {
  border-radius: 10px !important;
}
</style>

<style scoped>
.contact {
  background-color: #ffff;
  padding: 4px 0;
  max-width: 330px;
  line-height: 17.57px;
  color: #ff0000;
  border: 1px solid #ff0000;
  text-align: center;
  border-radius: 8px;
  margin: 20px auto;
}
.text-thanks {
  line-height: 17.57px;
  text-align: center;
}
.logo-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 25px 15px 30px 15px;
  border-bottom: 1px dashed #ececec;
}
.title-booking {
  text-align: center;
  font-size: 20px;
  margin: 10px 0 0 0;
}
.top-spacing {
  padding-top: 100px;
}
.tee-time-container {
  background: #ffff;
  box-shadow: 0px 4px 20px 0px #00000026;
  border-radius: 15px;
  min-height: 340px;
  margin-bottom: 20px;
  margin-right: auto;
}
.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}
.info-tee-time {
  padding: 15px;
}
.item-content {
  display: flex;
  justify-content: space-between;
}
.title-item {
  flex-shrink: 0;
  color: #787878;
  font-size: 14px;
}
.name-item {
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.pt-12 {
  padding-top: 12px;
}
.pb-0 {
  margin-bottom: 0px;
}
.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 70px !important;
  }
}
</style>
